import { defineStore } from "pinia";

// const ONE_DAY = 24 * 60 * 60 * 1000; // 1日
// const ONE_MINUTE = 60 * 1000; // 1分

// const customSessionStorage = {
//   setItem: (key: string, value: string) => {
//     const now = Date.now();
//     const saveObj = { value, savedAt: now };
//     sessionStorage.setItem(key, JSON.stringify(saveObj));
//   },
//   getItem: (key: string) => {
//     const raw = sessionStorage.getItem(key);
//     if (!raw) return null;
//     try {
//       const { value, savedAt } = JSON.parse(raw);
//       if (Date.now() - savedAt > ONE_DAY) {
//         sessionStorage.removeItem(key);
//         sessionStorage.setItem('__session_expired__', '1');
//         return null;
//       }
//       return value;
//     } catch {
//       sessionStorage.removeItem(key);
//       return null;
//     }
//   },
//   removeItem: (key: string) => sessionStorage.removeItem(key),
// }

// 状態の型定義
export interface ConditionState {
  buildingType: number;
  buildingStructure: number;
  buildingAge: number;
  prefId: number;
  buildingInsAmount: number | null;
  householdInsAmount: number | null;
  seismicYearsDiscount: number;
  damageContamination: boolean;
  floodDisaster: boolean;
  theftFlyingWaterDisturbance: boolean;
  windHailSnowDamage: boolean;
  hasEarthquakeInsurance: boolean;
  mailPmsFlg: boolean | null;
  name1: string;
  name2: string;
  nameKana1: string;
  nameKana2: string;
  email: string;
  // lastSavedAt: number;
}

export const useConditionStore = defineStore("conditionStore", {
  state: (): ConditionState => ({
    buildingType: 0,
    buildingStructure: 0,
    buildingAge: 0,
    prefId: 0,
    buildingInsAmount: null,
    householdInsAmount: null,
    seismicYearsDiscount: 0,
    damageContamination: false,
    floodDisaster: false,
    theftFlyingWaterDisturbance: true,
    windHailSnowDamage: true,
    hasEarthquakeInsurance: false,
    mailPmsFlg: true,
    name1: '',
    name2: '',
    nameKana1: '',
    nameKana2: '',
    email: '',
    // lastSavedAt: Date.now()
  }),
  actions: {
    // 条件をクリア
    clearCondition() {
      this.buildingType = 0;
      this.buildingStructure = 0;
      this.buildingAge = 0;
      this.prefId = 0;
      this.buildingInsAmount = null;
      this.householdInsAmount = null;
      this.seismicYearsDiscount = 0;
      this.damageContamination = false;
      this.floodDisaster = false;
      this.theftFlyingWaterDisturbance = true;
      this.windHailSnowDamage = true;
      this.hasEarthquakeInsurance = false;
      this.mailPmsFlg = true;
      this.name1 = '';
      this.name2 = '';
      this.nameKana1 = '';
      this.nameKana2 = '';
      this.email = '';
      // this.lastSavedAt = Date.now();
    },
    setMailPmsFlg(val: boolean) {
      this.mailPmsFlg = val;
    },
    // isExpired() {
    //   return Date.now() - this.lastSavedAt > ONE_DAY;
    // },
    // updateLastSavedAt() {
    //   this.lastSavedAt = Date.now();
    // }
  },
  // 永続化
  persist: {
    key: 'conditionStore',
    storage: process.client ? sessionStorage : undefined
  }
});
